import { Button, ModalBody, ModalHeader } from "reactstrap";
import { Trans, useTranslation } from "react-i18next";
import { useMemo, useState } from "react";
import { keyBy, reduce } from "lodash";
import { useConfirmModal, useXeroClient } from "../../../hooks";
import { NotificationManager } from "react-notifications";

const useSelected = (items, pk, selected) => {
  const itemsByPk = useMemo(() => keyBy(items, pk), [items, pk]);

  return useMemo(
    () =>
      reduce(
        selected,
        (acc, v, k) => {
          if (v && itemsByPk[k]) acc.push(itemsByPk[k]);
          return acc;
        },
        []
      ),
    [itemsByPk, selected]
  );
};

export const BulkVoidActions = ({
  selected: selectedProp,
  url,
  pk,
  items,
  onSuccess,
}) => {
  const { t } = useTranslation();
  const selected = useSelected(items, pk, selectedProp);
  const [action, setAction] = useState();
  const num = selected.length;
  const { Modal, isOpen, setIsOpen } = useConfirmModal();
  const client = useXeroClient();

  const actionText = useMemo(
    () =>
      ({
        VOIDED:t("void")
      }[action]),
    [t, action]
  );

  const openModel = (action) => () => {
    setAction(action);
    setIsOpen(true);
  };

  async function onConfirm() {
    const failed = [];
    const success = [];

    for (const i of selected) {
      try {
        await client.put(`${url}`, {
          ...i,
          Status: action,
        });
      } catch (err) {
        console.error(err);
        failed.push(i);
        continue;
      }
      success.push(i);
    }

    if (failed.length) {
      NotificationManager.error(
        t(
          "{{ failed }} failed to {{ action }}, please check all required fields are complete",
          {
            failed: failed.length,
            action: actionText,
          }
        )
      );
    }

    if (success.length) {
      NotificationManager.success(
        t("{{ success }} succeeded to {{ action }}", {
          success: success.length,
          action: actionText,
        })
      );
    }

    await onSuccess?.();
  }

  return (
    <div className="">
      {isOpen && (
        <Modal onConfirm={onConfirm}>
          <ModalHeader>
            <Trans>Confirm</Trans>
          </ModalHeader>
          <ModalBody>
            <Trans>
              You have selected {{ num }} item to {{ action: actionText }}.
            </Trans>
          </ModalBody>
        </Modal>
      )}
      <Button
        onClick={openModel("VOIDED")}
        size="sm"
        color="danger"
        disabled={!num}
        className="ml-0 mr-2"
      >
        <span >
          <Trans>Void</Trans>
        </span>
      </Button>
    </div>
  );
};
